import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import {SampleStatusDto} from "../../customs/_models/Sample.status.dto";

@Injectable({
  providedIn: 'root'
})
export class SampleStatusService {

    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }

    public fetchSampleStatusList(): Observable<SampleStatusDto[]>{
        console.log(this.endpoints.sample_status_base_endpoint)
        return this.http.get<SampleStatusDto[]>(this.endpoints.sample_status_base_endpoint);
    }
}
